<template>
  <b-modal id="locations-modal" centered size="large" hide-header hide-footer>
    <div class="locations-modal px-1">
      <h2 class="locations-modal__title">
        <inline-svg
          :src="require('@/assets/images/icons/dashboard/card.svg')"
        />
        أماكن عرض الخدمة / المنتج في المتجر
      </h2>

      <span class="locations-modal__label">عرض كل أقسام المتجر</span>
      <div class="locations-modal__box">
        <div class="table-responsive">
          <table class="table table-borderless locations-modal__table">
            <thead>
              <tr>
                <th scope="col">اسم المجموعة</th>
                <th scope="col">المكان</th>
                <th scope="col">حالة المجموعة</th>
                <th scope="col">عدد المنتجات</th>
                <th scope="col">ترتيب عرض المنتج</th>
              </tr>
            </thead>
            <VuePerfectScrollbar tagname="tbody">
              <tr v-for="(location, index) in locations" :key="index">
                <td scope="row">
                  <b-form-checkbox value="A">
                    {{ location.groupName }}</b-form-checkbox
                  >
                </td>

                <td>{{ location.name }}</td>
                <td>
                  <span
                    class="toggle-show-icon"
                    @click="location.show = !location.show"
                    ><feather-icon
                      :icon="location.show ? 'EyeIcon' : 'EyeOffIcon'"
                      size="20"
                  /></span>
                </td>
                <td>{{ 2 + index }}</td>
                <td>
                  <b-form-select :value="location.order" :options="options" />
                </td>
              </tr>
            </VuePerfectScrollbar>
          </table>
        </div>
      </div>

      <div class="modal-actions mt-3">
        <button class="btn px-4 btn--gradient-green" @click="hideModal">
          حفظ الاختيارات
        </button>
        <button class="btn px-4 btn--gray ml-1" @click="hideModal">
          الغاء
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { BModal, BFormSelect, BFormCheckbox } from "bootstrap-vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
export default {
  name: "ProductsLocationModal",
  components: {
    BModal,
    BFormSelect,
    BFormCheckbox,
    VuePerfectScrollbar,
  },
  data() {
    return {
      options: [
        { value: null, text: "اختر النوع", disabled: true },
        { value: "1", text: "1" },
        { value: "2", text: "2" },
      ],
      locations: [
        {
          show: true,
          groupName: "العروض الخاصة #1",
          name: "الصفحة الرئيسية #1",
          order: "1",
        },
        {
          show: true,
          groupName: "العروض الخاصة #2",
          name: "الصفحة الرئيسية #2",
          order: "2",
        },
        {
          show: false,
          groupName: "العروض الخاصة #3",
          name: "الصفحة الرئيسية #3",
          order: null,
        },
        {
          show: false,
          groupName: "العروض الخاصة #4",
          name: "الصفحة الرئيسية #4",
          order: null,
        },
        {
          show: false,
          groupName: "العروض الخاصة #5",
          name: "الصفحة الرئيسية #5",
          order: null,
        },
        {
          show: false,
          groupName: "العروض الخاصة #6",
          name: "الصفحة الرئيسية #6",
          order: null,
        },
      ],
    };
  },
  methods: {
    hideModal() {
      this.$bvModal.hide("locations-modal");
    },
  },
};
</script>
